import React, {
  useEffect, useRef
} from 'react';
import _ from 'lodash';
import {
  Box,
  Container,
  Grid,
  makeStyles,
} from '@material-ui/core';
import styled from 'styled-components';

import { useLanguage } from '../../../../context/language/language';
import useResponsive from '../../../../utils/responsive';
import { Button } from '../../../common';
import Layout from '../Layout';
import useDeliveryControlFlow from '../../../common/hook/useDeliveryControlFlow';
import { defaultModalSize, mobileContentContainerHeight } from '../modalSize';

const useStyle = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('md')]: {
      paddingTop: 0,
    },

    [theme.breakpoints.up('lg')]: {
      padding: 0,
    },
    [theme.breakpoints.down('xs')]: {
      padding: '0 20px'
    },
  },
  
  condition: {
    color: theme.custom.colors.grey550,
    '& ol': {
      margin: 0,
      padding: '0 24px'
    },
    [theme.breakpoints.down('xs')]: {
      '& ol': {
        padding: '8px 24px',
      },
    }
  },
  customButton: {
    ...theme.fonts.textL,
    width: 328,
    fontWeight: 700
  },
}));

const Main = styled.div(({ theme, width }) => ({
  width,
  overflow: theme.isTabletOrMobile ? 'auto' : 'initial',
  paddingBottom: '65px',
  '&::-webkit-scrollbar-track': {
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
  },
  '&::-webkit-scrollbar': {
    width: 4,
    backgroundColor: '#FFFFFF',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 4,
    backgroundColor: '#E8E8E8',
  },
}));

const Title = styled.div(() => ({
  overflow: 'hidden',
  width: '100%',
  display: '-webkit-box',
  textAlign: 'center',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis',
}));


const ButtonGroup = styled(Grid)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  bottom: 0,
  backgroundColor: 'white',
  zIndex: 10,
  padding: '24px 12px',
  gap: 14,

  ...theme.isMobile && {
    borderTopWidth: 0.5,
    borderTopStyle: 'solid',
    borderTopColor: theme.colors.grey100,
    padding: '12px 12px 8px 12px',
    gap: 0
  },
}));

const CustomButton = styled(Button)(({ theme }) => ({
  ...theme.fonts.header5,
}));

export default function TermsAndConditionInstallment({
  onNext,
  onBack,
  onClose,
  modalRef,
}) {
  const word = useLanguage();
  const classes = useStyle();

  const deliveryControl = useDeliveryControlFlow();
  const { isMobile, isTablet, isTabletOrMobile } = useResponsive();
  const handleCancel = () => onClose();


  const contentContainerRef = useRef(null);
  useEffect(() => {
    const offset = defaultModalSize.mobile.offset;
    if (contentContainerRef?.current?.style) {
      mobileContentContainerHeight(contentContainerRef, isMobile, modalRef, offset);
    }
  }, [contentContainerRef]);

  return (
    <Layout
      title={(
        <Title>
          {word('Payment.Installment.Terms.Header')}
        </Title>
      )}
      onBack={onBack}
      backButtonShown={isMobile ? true : deliveryControl.stackSize > 1}
      onClose={isMobile ? false : onClose}
      width={isTablet ? defaultModalSize.tablet.width : defaultModalSize.desktop.width}
      height="auto"
      isDefaultModalSize={false}
      isShowBorderBottom
      isTitleCenter
      footer={!isMobile && (
        <Button
          id="close-btn"
          data-cta-name-en="close"
          data-cta-name-th="ปิด"
          data-cta-type="Button"
          primary
          className={classes.customButton}
          onClick={handleCancel}
        >
          {word('General.Close')}
        </Button>
      )}
    >
      <Container className={classes.root} ref={contentContainerRef}>
        <Main style={{ maxHeight: !isMobile && '50vh' }}>
          <Box>
            <div className={classes.condition} dangerouslySetInnerHTML={{ __html: word('Payment.Installment.Terms.Condition.Web') }} />
            {isMobile && (
            <ButtonGroup container justify="center">
              <Grid item xs={6} md={4} sm={4} className={classes.buttonWrapperRight}>
                <CustomButton
                  id="close-btn"
                  data-cta-name-en="close"
                  data-cta-name-th="ปิด"
                  data-cta-type="Button"
                  primary
                  fullWidth
                  onClick={handleCancel}
                >
                  {word('General.Close')}
                </CustomButton>

              </Grid>
            </ButtonGroup>
            )}
          </Box>
        </Main>
      </Container>
    </Layout>
  );
}
